export const homeUrl = "/"
export const objectiveDetails = "/objectiveDetails"
export const login = "/login"
export const mailLink = "/mailLink"
export const resetPassword = "/resetPassword"